<template>
  <div class="to_journalism">
    <div class="heading">{{ $t('message.news.pageTitle') }}</div>
    <div class="context">
      <van-search shape="round" :placeholder="$t('message.news.searchPlaceholder')" @search="onSearch" @clear="onCancel"
        @input="inputSearch" v-model="query.titleContent">
      </van-search>
      <!-- tab栏 -->
      <div class="tab" v-if="tabShow">
        <van-tabs v-model="tabActive" title-inactive-color="#151515" title-active-color="#3562FF" @change="tabSelect">
          <van-tab :title="$t('message.news.whole')" :key="-1"></van-tab>

          <van-tab v-for="(item, index) in tabList" :title="item" :key="index"></van-tab>
          <!-- <div class="drop_down">
            <van-icon name="arrow-down" @click="clickDown" />
          </div> -->
        </van-tabs>
        <div class="drop_down">
          <van-icon name="arrow-down" @click="clickDown" />
        </div>
      </div>

      <!-- 全部频道 -->
      <div class="all_channels" v-if="!tabShow" ref="all_channels">
        <div class="all_channels_head">
          <div>{{ $t('message.news.allChannels') }}</div>
          <div><van-icon name="arrow-up" @click="clickUp" /></div>
        </div>
        <div class="all_channels_context">
          <div class="all_channels_context_item" :class="{
      all_channels_context_active: tabActive - 1 == index
    }" v-for="(item, index) in tabList" :key="index" @click="clickAllItem(item, index)">
            {{ item }}
          </div>
        </div>
      </div>

      <!-- 影像主体内容 -->
      <div class="context_main">
        <div class="context_main_box">
          <van-list offset="100" v-model="loading" :finished="finished" @load="search()">
            <div class="context_main_item" v-for="(item, index) in dataList" :key="index"
              @click="clickToDetails(item, index)">
              <div class="article_title">{{ item.newsTitle }}</div>
              <!-- 单图 -->
              <div class="article_img" v-if="item.coverImages && item.coverImages.length <= 1">
                <van-image radius="4" fit="cover" :src="item.coverImage" />
              </div>
              <!-- 多图 -->
              <div class="article_img_two" v-else>
                <div class="article_img_two_item" v-for="(it, ind) in item.coverImages" :key="ind" :style="{
      margin: ind == 1 ? '0 8px' : 0
    }" v-show="ind < 3">
                  <van-image radius="4" fit="cover" height="56" :src="it" />
                </div>
              </div>
              <!-- 视频 -->
              <div class="article_video" v-if="false">
                <video
                  src="https://outin-f64a2f9ac6e511ecae8d00163e1a625e.oss-cn-shanghai.aliyuncs.com/c4e779e5132d48048ecd527b3717c715/57e5b8c6604642a6b1bb9759485d3b91-d4f21e3c055da4b7a4989e68f526b19f-2k.mp4?Expires=1669189135&OSSAccessKeyId=LTAI8bKSZ6dKjf44&Signature=QjbVl9mz4KrFfqUUK%2BWiAIqJkbg%3D"></video>

                <div class="play">
                  <van-icon name="play" color="#fff" />
                </div>
              </div>

              <!-- 发布时间 -->
              <div class="created_time">
                {{ $t('message.news.publishedOn') }}{{ item.putawayTime }}
                {{ $t('message.news.pictureNet') }}
                {{ item.clubOuterName }}
              </div>
            </div>
          </van-list>
        </div>
      </div>
    </div>
    <!-- to  去投稿 -->
    <div class="to_contribute" @click="clickToContribute">
      <img src="../../../static/image/2565.png" alt="" />
    </div>
    <!-- 用户是否认证弹窗 -->
    <div class="authentication_toast" @click.self="clickHideToast" v-show="toastShow">
      <div class="toast_center">
        <div class="toast_center_main">
          <div class="context_icon">
            <img src="../../../static/image/2666.png" alt="" />
          </div>

          <div class="context_text">
            {{ $t('message.news.realnameTip') }}
          </div>

          <div class="context_button" @click="clickToAuthentication">
            {{ $t('message.news.toCrtification') }}
          </div>
        </div>

        <div class="close" @click="clickHideToast"><van-icon name="cross" /></div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCookie } from '@/utils/cookie'
import { Toast } from 'vant'
const defaultQuery = Object.freeze({
  order: 'desc',
  orderType: '1',
  endTime: '',
  explain: '',
  isDelete: '1',
  isEaveInformation: '',
  isNewsPool: '2',
  isPutaway: '2',
  isRecommend: '2',
  isSendBack: null,
  manuscriptStatus: 4,
  manuscriptType: '',
  isTop: '2',
  newsCity: '',
  newsClassification: null,
  newsClassifications: null,
  newsCode: '',
  newsProvince: '',
  newsTitle: '',
  nickName: '',
  organizationId: 0,
  pageNum: 1,
  pageSize: 10,
  realName: '',
  startTime: '',
  appId: null,
  titleContent: ''
})
import {
  listAll,
  selectIsAuthentication,
  updateNewsNumber,
  blacklistWordAll,
  searchingWordSave
} from '@/api/journalism.js'
export default {
  components: {},
  data() {
    return {
      query: { ...defaultQuery },
      // tab栏数据
      tabList: this.$t('message.news.tabList'),
      // tab选中的值
      tabActive: 1,
      // tab栏和全部频道的切换
      tabShow: true,
      // 全部频道的选择
      loading: false,
      finished: false,
      dataList: [],
      toastShow: false
    }
  },
  computed: {},
  watch: {
    tabShow(val) {
      if (!val) {
        document.body.addEventListener('touchmove', this.scrollHandle, { passive: false })
        // document.body.addEventListener('WheelEvent ', this.scrollHandle, { passive: false })
      } else {
        document.body.removeEventListener('touchmove', this.scrollHandle, { passive: false })
        // document.body.removeEventListener('WheelEvent ', this.scrollHandle, { passive: false })
      }
    }
  },
  created() {

  },
  methods: {
    scrollHandle(e) {
      e.preventDefault()
    },
    // 搜索栏搜索触发事件
    onSearch(val) {
      if (!val.replace(/(^\s*)|(\s*$)/g, '')) {
        return
      }
      this.query.titleContent = val
      this.query.pageNum = 1
      this.dataList = []
      this.finished = false
      blacklistWordAll({
        blacklist: val,
        enableOrNot: true,
        pageNum: 1,
        pageSize: 10,
        remark: '',
        searchCriteria: ''
      }).then(({ data: res }) => {
        if (res.data.list?.length) {
          Toast({
            message: `您输入的${res.data.list
              .map((item) => `"${item.blacklist}"`)
              .join(',')}属于黑名单，请重新输入文字`,
            position: 'top'
          })
        } else {
          let obj = { ...this.query, newsClassifications: null, isRecommend: null }
          this.search('查询', obj)
        }
      })
    },
    // 搜索栏内容清空事件
    onCancel() {
      this.query.titleContent = ''
      this.query.pageNum = 1
      this.dataList = []
      this.finished = false
      this.search()
    },
    inputSearch(val) {
      if (!val) {
        this.onCancel()
      }
    },
    async search(type, obj) {
      this.loading = true

      const { data: res } = await listAll(obj || this.query)
      if (res.resultCode == 200) {
        if (type === '查询') {
          this.dataList = res.data.list
          const query = {
            searchingWord: this.query.titleContent
          }
          searchingWordSave(query).then((reslut) => {
            console.log(reslut)
          })
        } else {
          this.dataList = [...this.dataList, ...res.data.list]
        }
        this.loading = false
        if (res.data.hasNextPage) {
          this.query.pageNum++
        } else {
          this.finished = true
        }
      } else {
        this.finished = true
        this.loading = false
      }
    },
    // tab栏选中的事件
    tabSelect(name, title) {
      console.log(name, title, 'name, title')
      this.query.pageNum = 1
      this.dataList = []
      this.finished = false
      this.query.newsClassifications = []
      // console.log(title)
      if (title == '推荐' || title == 'Recommended') {
        // console.log('推荐')
        this.query.isRecommend = '2'
        this.query.newsClassifications = null
      } else if (title == this.$t('message.news.whole')) {
        this.query.isRecommend = null
        this.query.newsClassifications = null
      } else {
        // console.log('不推荐')
        this.query.isRecommend = null
        this.query.newsClassifications.push(name - 1)
      }

      this.search()
      this.finished = false
    },
    // 展示全部的搜索
    clickAllItem(item, index) {
      this.query.newsClassifications = []
      this.query.pageNum = 1
      this.dataList = []
      this.finished = false
      this.tabActive = index + 1
      if (item == '推荐' || item == 'Recommended') {
        this.query.isRecommend = '2'
        this.query.newsClassifications = null
      } else if (item == this.$t('message.news.whole')) {
        this.query.isRecommend = null
        this.query.newsClassifications = null
      } else {
        this.query.isRecommend = null
        this.query.newsClassifications.push(index)
      }
      this.search()
      this.finished = false
    },
    // 点击展示全部
    clickDown() {
      this.tabShow = false
      this.$refs.all_channels
    },
    // 点击收起
    clickUp() {
      this.tabShow = true
    },
    // 点击去投稿
    async clickToContribute() {
      let token = getCookie('token')
      let userId = getCookie('userId')
      if (!token) {
        Toast.fail(this.$t('message.home.first_log'))
        setTimeout(() => {
          this.$router.push({
            name: 'Login'
          })
        }, 1000)
        return
      }

      const { data: res } = await selectIsAuthentication({
        appId: userId
      })
      // 1->未认证;2->认证中;3->已认证  4认证失败 5已加入黑名单
      // console.log(res)
      // let token = false
      if (token && res.data != 1 && res.data != 2 && res.data != 4 && res.data != 5) {
        this.$router.push({
          path: '/toJournalismList/contribute',
          query: {
            index: 2
          }
        })
      } else if (res.data == '2') {
        Toast({
          message: `您的身份正在审核中，等审核通过后，才能进行投稿`,
          position: 'top'
        })
      } else if (res.data == '1' || res.data == '4') {
        this.toastShow = true
      } else if (res.data == '5') {
        Toast({
          message: `您的账号目前异常，暂不能投稿，请去客服中心联系管理员查看具体原因`,
          position: 'top'
        })
      }
    },
    // 前往影像详情
    async clickToDetails(item, index) {
      const { data: res } = await updateNewsNumber({
        newsId: item.id
      })
      console.log(this.dataList, 'this.dataList')
      this.$router.push({
        path: '/toJournalismList/journalismDetails',
        query: {
          id: item.id,
          index,
          item: JSON.stringify(this.query)

          // item: JSON.stringify(this.dataList)
        }
      })
    },
    // 隐藏弹窗
    clickHideToast() {
      this.toastShow = false
    },
    // 去认证
    clickToAuthentication() {
      this.$router.push({
        path: '/user/certification'
      })
    }
  }
}
</script>
<style scoped lang="less">
.to_journalism {
  background-color: #f6f6f6;

  .heading {
    background-color: #fff;
    width: 100%;
    text-align: center;
    padding: 7px 0;
  }

  .context {
    .tab {
      font-size: 16px;
      position: relative;
      padding-right: 10px;

      /deep/.van-tabs__line {
        width: 37px;
        height: 2px;
        border-radius: 2px;
        background-color: #3562ff;
        bottom: 20px;
      }

      /deep/.van-tabs__nav--complete {
        padding-right: 10px;
      }

      .drop_down {
        height: 100%;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 37px;
        // height: 24px;
        background-image: linear-gradient(to right,
            rgba(255, 255, 255, 0) -100%,
            rgba(255, 255, 255, 1) 60%);
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 10px;
        box-sizing: border-box;
      }
    }

    @keyframes all_channels {
      0% {
        height: 0;
      }

      100% {
        height: 196px;
      }
    }

    .all_channels {
      overflow: hidden;
      animation: all_channels 0.2s linear;
      box-shadow: 0px 5px 10px -7px #999999;
      background-color: #fff;
      position: absolute;
      // top: 0;
      z-index: 100;

      // transform: translateY(-15px);
      .all_channels_head {
        width: 100%;
        height: 44px;
        line-height: 44px;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 9px 0 16px;
      }

      .all_channels_context {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        padding: 0 0 0 13px;

        .all_channels_context_item {
          padding: 5px 12px;
          color: #151515;
          border-radius: 58px;
          border: 1px solid #999999;
          margin-right: 12px;
          margin-bottom: 10px;
        }

        .all_channels_context_active {
          color: #3562ff;
          border: 1px solid #3562ff;
        }
      }
    }

    .context_main {
      .context_main_box {
        padding: 10px 14px;

        .context_main_item {
          padding: 7px 9px;
          background-color: #fff;
          border-radius: 10px;
          margin-bottom: 0.2667rem;

          .article_title {
            font-size: 18px;
            margin-bottom: 10px;
            color: #3c3b3f;
          }

          .article_img {
            font-size: 0;
            margin-bottom: 10px;
            text-align: center;

            /deep/.van-image {
              width: auto !important;
              max-width: 100%;
              height: auto !important;
            }
          }

          .article_img_two {
            display: flex;
            height: 56px;
            margin-bottom: 10px;

            .article_img_two_item {
              width: 33%;
              height: 56px;

              /deep/.van-image {
                width: 100%;
              }
            }
          }

          .article_video {
            position: relative;

            video {
              border-radius: 4px;
              width: auto !important;
              max-width: 100%;
              height: auto !important;
              margin-bottom: 10px;
            }

            .play {
              width: 28px;
              height: 28px;
              border-radius: 50%;
              border: 2px solid #fff;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }

          .created_time {
            font-size: 14px;
            color: #999999;
          }
        }
      }
    }
  }

  .to_contribute {
    width: 68px;
    height: 64px;
    z-index: 99999;
    // box-shadow: 0px 0px 12px rgb(182, 207, 255);
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    color: #fff;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .authentication_toast {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    // opacity: 0.8;
    // background-color: #000000;
    background: rgba(0, 0, 0, 0.8);
    z-index: 100000;
    display: flex;
    align-items: center;
    justify-content: center;

    .toast_center {
      width: 267px;
      height: 354px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      .toast_center_main {
        width: 100%;
        height: 300px;
        background-color: #fff;
        border-radius: 8px;
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        align-items: center;

        .context_icon {
          width: 113px;
          height: 122px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .context_text {
          color: #1a1a1a;
          font-size: 13px;
          max-width: 221px;
          text-align: center;
        }

        .context_button {
          width: 144px;
          height: 42px;
          border-radius: 21px;
          background-color: #3562ff;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 14px;
        }
      }

      .close {
        width: 26px;
        height: 26px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        border: 2px solid #fff;
      }
    }
  }
}
</style>
